/*MATERIAL UI*/
import { IconButton, Modal, Tooltip } from "@mui/material";
import { DataGrid, GridColumns } from "@mui/x-data-grid";

/*ICONS*/
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import DescriptionIcon from '@mui/icons-material/Description';

/*OTHERS*/
import React, { useEffect, useState } from "react";
import Utils from "../../helper/utils";
import AcompanhamentoEntregaFOB from "../../components/classes/AcompanhamentoEntregaFOB";
import AcompanhamentoEntregaFOBDataset from "../../components/data/AcompanhamentoEntregaFOBDataset";
import Parceiro from "../../components/classes/Parceiro";
import ContratoDataset from "../../components/data/ContratoDataSet";
import SkuDataSet from "../../components/data/UnidadeArmazenamentoDataSet";
import AcompanhamentoCargaFOBParameters from "../../components/classes/AcompanhamentoCargaFOBParameters";
import AcompanhamentoCargaItensModal from "./modalItensFOB/acompanhamentoCargaItensModal";
import Filter from "./filter";

import styles from './detail.module.css';

import { useTranslation } from "react-i18next";

type Data = Array<Record<string, any>>;

export default function AcompanhamentoCargaGridFOB(
  props: AcompanhamentoCargaGridFOBPropsTypes
) {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState<Data>([]);
  const [filterPedido, setFilterPedido] = useState<string>('');
  const [filterItem, setFilterItem] = useState<string>('');
  const [filterContrato, setFilterContrato] = useState<string[]>([]);
  const [filterSku, setFilterSku] = useState<string[]>([]);
  const [openFilter, setOpenFilter] = useState<boolean>(false);
  const [handleFilter, setHandleFilter] = useState<boolean>(false);
  const [numerosContratoSap, setNumerosContratoSap] = useState<string[]>([]);
  const [skusNomes, setSkusNomes] = useState<string[]>([]);
  const [selectedPedido, setSelectedPedido] = useState<any>(null);

  const acompanhamentoEntregaFOBDataset: AcompanhamentoEntregaFOBDataset = new AcompanhamentoEntregaFOBDataset();
  const contratoDataSet = new ContratoDataset();
  const skuDataSet = new SkuDataSet();

  const codigoFornecedorSap = Number(localStorage.getItem("CodigoFornecedorSAPSelecionado"));
  const columns: GridColumns = [
    {
      field: "id",
      headerName: t("common.id"),
      width: 80,
      align: "center",
      headerAlign: "center",
      renderHeader: (item) => {
        return <div>#</div>;
      },
    },
    {
      field: "contrato",
      headerName: t("common.contract"),
      type: "string",
      width: 110,
      editable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "contratoSap",
      headerName: t("common.contractSap"),
      type: "string",
      width: 110,
      editable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "pedido",
      headerName: t("common.order"),
      type: "string",
      width: 110,
      editable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "clifor",
      headerName: t("pages.deliveriesFob.text.clifor"),
      type: "string",
      width: 110,
      editable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "quantidade",
      headerName: t("common.orderQuantity"),
      type: "string",
      width: 180,
      editable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (item) => {
        return (
          <p>
            {item.value ? item.value?.toString()?.replace('.', ',') : ""}
          </p>
        );
      },
    },
    {
      field: "dataRemessa",
      headerName: t("common.shipmentDate"),
      type: "date",
      width: 180,
      editable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (item) => {
        return (
          <p>{new Date(item.row.dataRemessa).toLocaleDateString("pt-BR")}</p>
        );
      },
    },
    {
      field: "dataEntrega",
      headerName: t("common.deliveryDate"),
      type: "date",
      width: 180,
      editable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (item) => {
        return (
          <p>{new Date(item.row.dataEntrega).toLocaleDateString("pt-BR")}</p>
        );
      },
    },
    {
      field: "remessa",
      headerName: t("common.shipping"),
      type: "string",
      width: 110,
      editable: false,
      align: "center",
      headerAlign: "center",
    },
    // {
    //   field: "tms",
    //   headerName: "TMS",
    //   type: "string",
    //   width: 110,
    //   editable: false,
    //   align: "center",
    //   headerAlign: "center",
    // },
    {
      field: "placaCarreta",
      headerName: t("pages.deliveriesFob.text.truckPlate"),
      type: "string",
      width: 180,
      editable: false,
      align: "center",
      headerAlign: "center",
    },
    // {
    //   field: "loadJDA",
    //   headerName: "LoadJDA",
    //   type: "string",
    //   width: 180,
    //   editable: false,
    //   align: "center",
    //   headerAlign: "center",
    // },
    {
      field: "placaCavalo",
      headerName: t("pages.deliveriesFob.text.trailerPlate"),
      type: "string",
      width: 180,
      editable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "carregamento",
      headerName: t("pages.deliveriesFob.text.orderItems"),
      type: "string",
      width: 180,
      editable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (item) => {
        return (
          <div>
            <Tooltip title={t("pages.deliveriesFob.text.showOrderItems")}>
              <span>
                <IconButton
                  onClick={() => handleClickShowSubTable(item)}
                  disabled={loading}
                >
                  <DescriptionIcon />
                </IconButton>
              </span>
            </Tooltip>
          </div>
        );
      },
    }
  ];

  const handleClickShowSubTable = (gridItem: any) => {
    setSelectedPedido(gridItem.row);
  }

  useEffect(() => {
    var filtro: AcompanhamentoCargaFOBParameters = new AcompanhamentoCargaFOBParameters();
    for (let intSKU of filterSku)
      filtro.skus.push(Number(intSKU));
    filtro.idFornecedor = props.parceiro.codigoFornecedorSAP.valueOf();
    filtro.pedido = Number(filterPedido);
    filtro.item = Number(filterItem);
    acompanhamentoEntregaFOBDataset
      .getAll(filtro)
      .then((result) => {
        fillTable(result);
        setLoading(false);
      });
  }, [handleFilter])

  useEffect(() => {
    fetchData()
      .catch(console.error);
  }, [])

  const fetchData = async () => {
    Utils.setDocumentTitle(t("pages.deliveriesFob.pageTitle"));
    var contratos = await contratoDataSet.ListarAtivos(codigoFornecedorSap);
    var skus = await skuDataSet.ListarAtivos();
    setNumerosContratoSap(contratos.map(x => x.numeroContrato + ''));
    setSkusNomes(skus.map(x => x.idSKU + ''));
  }

  const fillTable = (acompanhamentoEntregaFOBArr: AcompanhamentoEntregaFOB[]) => {
    let gridData: Data = [];
    acompanhamentoEntregaFOBArr.forEach(
      (item: AcompanhamentoEntregaFOB, index: number) => {
        let json = JSON.parse(AcompanhamentoEntregaFOB.toJson(item));
        json.id = index;
        gridData.push(json);
      }
    );
    setRows(gridData);
  }

  const handleClickFilter = async () => {
    setOpenFilter(false);
    setHandleFilter(!handleFilter);
  }

  const handleClickClearFilter = () => {
    setFilterItem("");
    setFilterPedido("");
    setFilterSku([]);
    setFilterContrato([]);
    setHandleFilter(!handleFilter);
  }

  const handleClickOpenFilter = () => {
    setOpenFilter(true);
  };

  return (
    <>
      {/* Ações no Cabeçalho */}
      <div className="containerToolbar">
        {filterItem == '' && filterPedido == '' && filterContrato.length == 0 && filterSku.length == 0 ? (
          <Tooltip title={t("pages.deliveriesFob.text.enableFiltering")}>
            <span>
              <IconButton
                onClick={handleClickOpenFilter}
                disabled={!(rows.length >= 0) || loading}
              >
                <FilterAltIcon />
              </IconButton>
            </span>
          </Tooltip>
        ) : (
          <Tooltip title={t("pages.deliveriesFob.text.disableFiltering")}>
            <span>
              <IconButton
                onClick={handleClickClearFilter}
                disabled={loading}
              >
                <FilterAltOffIcon />
              </IconButton>
            </span>
          </Tooltip>
        )}
      </div>
      <div className={styles.table}>
        <DataGrid
          loading={loading}
          rows={rows}
          columns={columns}
          rowsPerPageOptions={[50, 100, 250, 500]}
          onRowClick={handleClickShowSubTable}
          style={{ cursor: 'pointer' }}
        />
      </div>

      {/* Filtros de Pedidos */}
      <Filter
        openFilter={openFilter}
        setOpenFilter={setOpenFilter}
        filterItem={filterItem}
        setFilterItem={setFilterItem}
        filterPedido={filterPedido}
        setFilterPedido={setFilterPedido}
        handleClickFilter={handleClickFilter}
        filterContrato={filterContrato}
        setFilterContrato={setFilterContrato}
        filterSku={filterSku}
        setFilterSku={setFilterSku}
        filterSkuOptions={skusNomes}
        filterContratoOptions={numerosContratoSap}
      />

      {/* Modal Itens do Pedido */}
      <Modal
        open={selectedPedido}
        onClose={() => setSelectedPedido(null)}
        sx={{
          display: "flex",
          "justifyContent": "center",
          "alignItems": "center",
        }}
      >
        <AcompanhamentoCargaItensModal
          handleClose={() => setSelectedPedido(null)}
          data={selectedPedido}
        />
      </Modal>
    </>
  );
}

interface AcompanhamentoCargaGridFOBPropsTypes {
  parceiro: Parceiro;
}
